// extracted by mini-css-extract-plugin
export var printerCard = "_9z-1";
export var printerCardConfigured = "_9z-2";
export var printerCardError = "_9z-3";
export var printerCardsContainer = "_9z-0";
export var printerIcon = "_9z-8";
export var printerIconConfigured = "_9z-5";
export var printerIconContainer = "_9z-4";
export var printerIconError = "_9z-6";
export var printerIconUnconfigured = "_9z-7";